import { YinYangIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Compensation = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <YinYangIcon {...rest} size={Sizes[size]} color={fill} />;
};

Compensation.displayName = 'Compensation';
